module.exports = __webpack_public_path__ + "img/sample_01_big.a20ef967.gif";